import ExDefaultViewManager from "../default";
import {extend, defer, requestAnimationFrame} from "../../../utils/core";
import Snap from "../../../managers/helpers/snap";
import { EVENTS } from "../../utils/constants";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import { flatMap } from "lodash";

class ExContinuousViewManager extends ExDefaultViewManager {
    constructor(options, rendition) {
		super(options, rendition);

		//是否正在捲動
		this._isScrolling = false;

		//等待最後一次update
		this._finalUpdate = null;

		//等待之前章節載入
		this._isWaitEmitPrependSectionRollback = false;
		this._prependSectionRollbackFinish = new defer();

		//頁面內容尺寸
		this._constentSize = null;

		//區隔因章節載入捲動
		this._nowHorizontal = null;
		this._nowDelta = null;

        this.name = "continuous";

		this.settings = extend(this.settings || {}, {
			infinite: true,
			overflow: undefined,
			axis: undefined,
			writingMode: undefined,
			flow: "scrolled",
			offset: 500,
			offsetDelta: 250,
			width: undefined,
			height: undefined,
			snap: false,
			afterScrolledTimeout: 0,
			allowScriptedContent: false
		});

		extend(this.settings, options.settings || {});

		// Gap can be 0, but defaults doesn't handle that
		if (options.settings.gap != "undefined" && options.settings.gap === 0) {
			this.settings.gap = options.settings.gap;
		}

		this.viewSettings = {
			ignoreClass: this.settings.ignoreClass,
			axis: this.settings.axis,
			flow: this.settings.flow,
			layout: this.layout,
			width: 0,
			height: 0,
			forceEvenPages: false,
			allowScriptedContent: this.settings.allowScriptedContent
		};

		this.scrollTop = 0;
		this.scrollLeft = 0;
    }

    display(section, target){
		//console.log("display ---------------------------------------");
		this._isWaitEmitPrependSectionRollback = false;
		this._constentSize = null;
		return ExDefaultViewManager.prototype.display.call(this, section, target)
			.then(function () {
				return this.fill();
			}.bind(this));
	}
	
	setContentSize(size){
		if(!this._constentSize){
			this._constentSize = extend({}, size);
		}
	}

    fill(_full){
		var full = _full || new defer();
		this.q.pause();
		this.q.clear();
		this.q.enqueue(() => {
			return this.check();
		}).then((result) => {
			if (result) {
				this.fill(full);
			} else {
				full.resolve();
			}
		});
		this.q.run();

		return full.promise;
	}

    moveTo(offset){

		// var bounds = this.stage.bounds();
		// var dist = Math.floor(offset.top / bounds.height) * bounds.height;
		var distX = 0,
				distY = 0;

		var offsetX = 0,
				offsetY = 0;

		if(!this.isPaginated) {
			distY = offset.top;
			offsetY = offset.top+this.settings.offsetDelta;
		} else {
			distX = Math.floor(offset.left / this.layout.delta) * this.layout.delta;
			offsetX = distX+this.settings.offsetDelta;
		}

		if (distX > 0 || distY > 0) {
			this.scrollBy(distX, distY, true);
		}
	}

	afterResized(view){
		this.emit(EVENTS.MANAGERS.RESIZE, view.section);
	}

	// Remove Previous Listeners if present
	removeShownListeners(view){

		// view.off("shown", this.afterDisplayed);
		// view.off("shown", this.afterDisplayedAbove);
		view.onDisplayed = function(){};

	}

	/*continuousAdd(section){
		var view = this.createView(section, null, this.book, this.rendition);

		this.views.append(view);

		view.on(EVENTS.VIEWS.RESIZED, (bounds) => {
			view.expanded = true;
		});

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		// view.on(EVENTS.VIEWS.SHOWN, this.afterDisplayed.bind(this));
		view.onDisplayed = this.afterDisplayed.bind(this);
		view.onResize = this.afterResized.bind(this);

		return view.display(this.request);
	}*/

	continuousAppend(section){
		var view = this.createView(section, null, this.book, this.rendition);

		view.on(EVENTS.VIEWS.RESIZED, (bounds) => {
			view.expanded = true;
		});

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		this.views.append(view);

		view.onDisplayed = this.afterDisplayed.bind(this);

		return view;
	}

	createView(section, options, book, rendition) {
		return new this.View(section, extend(this.viewSettings, options), book, rendition);
	}

	continuousPrepend(section){

		var view = this.createView(section, null, this.book, this.rendition);

		view.on(EVENTS.VIEWS.RESIZED, (bounds) => {
			this.counter(bounds, section);
			view.expanded = true;
		});

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		this.views.prepend(view);

		view.onDisplayed = this.afterDisplayed.bind(this);

		return view;
	}

	scrollTo(x, y, silent){
		if(silent) {
			this.ignore = true;
		}

		if(!this.settings.fullsize) {
			this.stage.pauseScrolling();		
			this.container.scrollLeft = x;
			this.container.scrollTop = y;
			this.stage.recoverScrolling();
		} else {
			window.scrollTo(x,y);
		}
		this.scrolled = true;
	}

	scrollBy(x, y, silent){
		let dir = this.settings.direction === "rtl" ? -1 : 1;

		if(silent) {
			this.ignore = true;
		}

		if(!this.settings.fullsize) {
			this.stage.pauseScrolling();
			if(x) this.container.scrollLeft += x * dir;
			if(y) this.container.scrollTop += y;
			this.stage.recoverScrolling();
		} else {
			window.scrollBy(x * dir, y * dir);
		}
		this.scrolled = true;
	}

	counter(bounds, section){
		let rollbackPosition;
		if (this.book.package.metadata.layout === "pre-paginated") {
			if(this._isWaitEmitPrependSectionRollback){
				if(this.container.scrollHeight > this.container.clientHeight){
					rollbackPosition = this.scrollTop + bounds.heightDelta;
					if(this.scrollTop !== rollbackPosition){
						//console.log("pre-paginated counter scroll from", this.scrollTop, "+", bounds.heightDelta);
						this.scrollTo(this.scrollLeft, rollbackPosition, true);
					}else{
						this._prependSectionRollbackFinish.resolve();
					}
				}else{
					this._prependSectionRollbackFinish.resolve();
				}
				this._isWaitEmitPrependSectionRollback = false;
			}
		}else if(this.settings.axis === "vertical") {
			if(this.container.scrollHeight > this.container.clientHeight){
				rollbackPosition = this.scrollTop + bounds.heightDelta;
				if(this.scrollTop !== rollbackPosition){
					//console.log("counter scroll from", this.scrollTop, "+", bounds.heightDelta);
					this.scrollTo(this.scrollLeft, this.scrollTop + bounds.heightDelta, true);
				}else{
					this._prependSectionRollbackFinish.resolve();
				}
			}else{
				this._prependSectionRollbackFinish.resolve();
			}
		} else {
			if(this.container.scrollWidth > this.container.clientWidth){
				rollbackPosition = this.scrollLeft + bounds.widthDelta;
				if(this.scrollLeft !== rollbackPosition){
					//console.log("counter scroll from", this.scrollLeft, "+", bounds.widthDelta);
					this.scrollTo(this.scrollLeft + bounds.widthDelta, this.scrollTop, true);
				}else{
					this._prependSectionRollbackFinish.resolve();
				}
			}else{
				this._prependSectionRollbackFinish.resolve();
			}
		}
	}

	

	isVisible(view, offsetPrev, offsetNext, _container){
		var position = view.position();
		var container = _container || this.bounds();

		//固定版永遠為垂直捲動
		var horizontal = (this.book.package.metadata.layout !== "pre-paginated" && this.settings.axis === "horizontal");
		
		if(horizontal &&
			position.right > container.left - (offsetPrev * this._contentScale) &&
			position.left < container.right + (offsetNext  * this._contentScale)) {
			return true;
		} else if(!horizontal &&
			position.bottom > container.top - (offsetPrev * this._contentScale) &&
			position.top < container.bottom + (offsetNext  * this._contentScale)) {
			return true;
		}

		return false;

	}

	update(_offset){
		/*if(_offset){
			console.log("update ----------------------------------------");
		}else{
			console.log("update final ----------------------------------");
		}*/
		var container = this.bounds();
		var views = this.views.all();
		var viewsLength = views.length;
		var visible = [];
		//var offset = typeof _offset != "undefined" ? _offset : (this.settings.offset || 0);
		let defaultOffset = (this._nowHorizontal) ? this.settings.offset : this.layout.height * ( (this.rendition.book.settings.encryptType) ? 1 : (this.rendition.settings.isWebtoon || !this.layout.props.spread) ? 10 : 3 );
		var offset = typeof _offset != "undefined" ? _offset : (defaultOffset || 0);
		var isVisible;
		var view;

		var updating = new defer();

		var promises = [];
		for (var i = 0; i < viewsLength; i++) {
			view = views[i];

			isVisible = this.isVisible(view, offset, offset, container);

			if(isVisible === true) {
				if (!view.displayed) {
					let displayed = view.display(this.request).then(function(view){
						return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
							return view;
						});
					}.bind(this)).then(function (view) {
						if(view.contents){
							//確認內容最後尺寸已就緒
							return view.contents.allContentOnloadCheck().then(() => {
								this.updateLayout();
								if(this.rendition._layout.name !== "pre-paginated"){
									return this.sleep(this._waitLayoutUpdateTime).then(()=>{
										return view.contents.finalSizeCheck().then(() => {
											return view;
										});
									});
								}else{
									return view.contents.finalSizeCheck().then(() => {
										view.setEmptyPage(view.contents._backgroundSize);
										this.setContentSize(view.contents._backgroundSize);
										return view;
									});
								}
							});
						}else{
							return view;
						}
					}.bind(this))
						.then(function (view) {
							view.show();
						}, (err) => {
							view.hide();
						});
					promises.push(displayed);
				}else {
					view.show();
				}
				visible.push(view);
			} else {
				this.q.enqueue(view.temporaryDestory.bind(view));
				clearTimeout(this.trimTimeout);
				this.trimTimeout = setTimeout(function(){
					this.q.enqueue(this.trim.bind(this));
				}.bind(this), 30);
			}

		}

		if(promises.length){
			return Promise.all(promises).then(() => {
					if(this._finalUpdate && !_offset){
						this._finalUpdate.resolve();
					}
				}).catch((err) => {
					updating.reject(err);
				});
		} else {
			if(this._finalUpdate && !_offset){
				this._finalUpdate.resolve();
			}
			updating.resolve();
			return updating.promise;
		}

	}

	check(_offsetLeft, _offsetTop){

		var checking = new defer();

		var newViews = [];
		
		//固定版永遠為垂直捲動
		var horizontal;
		this._nowHorizontal = horizontal = (this.book.package.metadata.layout !== "pre-paginated" && this.settings.axis === "horizontal");

		//調整 delta 計算方式
		var delta;
		if(horizontal){
			delta = (_offsetLeft) ? _offsetLeft : this.settings.offset;
		}else{
			delta = (_offsetTop) ? _offsetTop : this.layout.height * ( (this.rendition.book.settings.encryptType) ? 1 : (this.rendition.settings.isWebtoon || !this.layout.props.spread) ? 10 : 3);
		}
		this._nowDelta = delta || 0;

		var bounds = this._bounds; // bounds saved this until resize

		let offset = horizontal ? this.scrollLeft : this.scrollTop;
		let visibleLength = horizontal ? Math.floor(bounds.width) : bounds.height;
		let contentLength = horizontal ? this.container.scrollWidth : this.container.scrollHeight;
		let writingMode = (this.writingMode && this.writingMode.indexOf("vertical") === 0) ? "vertical" : "horizontal";
		let rtlScrollType = this.settings.rtlScrollType;
		let rtl = this.settings.direction === "rtl";

		if (!this.settings.fullsize) {
			// Scroll offset starts at width of element
			if (rtl && rtlScrollType === "default" && this.book.package.metadata.layout !== "pre-paginated" && writingMode === "horizontal") {
				offset = contentLength - visibleLength - offset;
			}
			// Scroll offset starts at 0 and goes negative
			if (rtl && rtlScrollType === "negative" && this.book.package.metadata.layout !== "pre-paginated" && writingMode === "horizontal") {
				offset = offset * -1;
			}
		} else {
			// Scroll offset starts at 0 and goes negative
			if ((horizontal && rtl && rtlScrollType === "negative") ||
				(!horizontal && rtl && rtlScrollType === "default")) {
				offset = offset * -1;
			}
		}

		let appendDisplayed = null;
		let append = () => {
			let last = this.views.last();
			let next = last && last.section.next();
			if(next) {
				appendDisplayed = new defer();
				let appendViews = [next];
				newViews.push({"view":this.continuousAppend(next),"type":"append", "appendDisplayed":appendDisplayed, "appendViews": appendViews});
				if(this.book.package.metadata.layout === "pre-paginated"){
					//固定版
					let nextFlow = this.handleNextPrePaginated(null, next, this.add, true);
					if(nextFlow){
						appendViews.push(nextFlow);
						newViews.push({"view":this.continuousAppend(nextFlow),"type":"append", "appendDisplayed":appendDisplayed, "appendViews": appendViews});
					}
				}
			}
		};

		let prepend = () => {
			let first = this.views.first();
			let prev = first && first.section.prev();
			this._prependSectionRollbackFinish = new defer();
			if(prev) {
				//console.log("Add Append Segmentation !!!!!");
				this.views.addSegmentation();
				newViews.push({"view":this.continuousPrepend(prev),"type":"prepend", "appendDisplayed":appendDisplayed});
				this._isWaitEmitPrependSectionRollback = true;
				if(this.book.package.metadata.layout === "pre-paginated"){
					//固定版
					let prevFlow = this.handlePrevPrePaginated(null, prev, this.prepend, true);
					if(prevFlow){
						newViews.push({"view":this.continuousPrepend(prevFlow),"type":"prepend", "appendDisplayed":appendDisplayed});
					}
				}

			}else{
				this._prependSectionRollbackFinish.resolve();
				this._isWaitEmitPrependSectionRollback = false;
			}
		};

		let end = offset + visibleLength + delta;
		let start = offset - delta;

		//console.log("check -----------------------------------------");
		//console.log('offect:', offset, 'visibleLength:', visibleLength, 'delta:', delta);
		if (end >= contentLength) {
			//console.log(`append(end:${end} >= contentLength:${contentLength}):`, true);
			append();
		}else{
			//console.log(`append(end:${end} >= contentLength:${contentLength}):`, false);
		}
		
		
		if (start < 0) {
			//console.log(`prepend(start:${start} < 0):`, true);
			prepend();
		}else{
			//console.log(`prepend(start:${start} >= 0):`, false);
		}

		let promises = newViews.map((viewData) => {
			switch(viewData.type){
				case "prepend": if(viewData.appendDisplayed){
								return viewData.appendDisplayed.promise.then(()=>{
									return viewData.view.display(this.request).then(function(view){
										return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
											return view;
										});
									}.bind(this)).then(function (view) {
										if(view.contents){
											//確認內容最後尺寸已就緒
											return view.contents.allContentOnloadCheck().then(() => {
												this.updateLayout();
												if(this.rendition._layout.name !== "pre-paginated"){
													return this.sleep(this._waitLayoutUpdateTime).then(()=>{
														return view.contents.finalSizeCheck().then(() => {
															return view;
														});
													});
												}else{
													return view.contents.finalSizeCheck().then(() => {
														view.setEmptyPage(view.contents._backgroundSize);
														this.setContentSize(view.contents._backgroundSize);
														return view;
													});
												}
											});
										}else{
											return view;
										}
									}.bind(this));
								});
							  }else{
								return viewData.view.display(this.request).then(function(view){
									return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
										return view;
									});
								}.bind(this)).then(function (view) {
									if(view.contents){
										//確認內容最後尺寸已就緒
										return view.contents.allContentOnloadCheck().then(() => {
											this.updateLayout();
											if(this.rendition._layout.name !== "pre-paginated"){
												return this.sleep(this._waitLayoutUpdateTime).then(()=>{
													return view.contents.finalSizeCheck().then(() => {
														return view;
													});
												});
											}else{
												return view.contents.finalSizeCheck().then(() => {
													view.setEmptyPage(view.contents._backgroundSize);
													this.setContentSize(view.contents._backgroundSize);
													return view;
												});
											}
										});
									}else{
										return view;
									}
								}.bind(this));
							  }
							  break;
				case "append": return viewData.view.display(this.request).then(function(view){
									return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
										return view;
									});
								}.bind(this)).then(function (view) {
									if(view.contents){
										//確認內容最後尺寸已就緒
										return view.contents.allContentOnloadCheck().then(() => {
											this.updateLayout();
											if(this.rendition._layout.name !== "pre-paginated"){
												return this.sleep(this._waitLayoutUpdateTime).then(()=>{
													return view.contents.finalSizeCheck().then(() => {
														viewData.appendViews.splice(-1);
														if(viewData.appendViews.length){
															viewData.appendDisplayed.resolve();
														}

														return view;
													});
												});
											}else{
												return view.contents.finalSizeCheck().then(() => {
													viewData.appendViews.splice(-1);
													if(viewData.appendViews.length === 0){
														viewData.appendDisplayed.resolve();
													}

													view.setEmptyPage(view.contents._backgroundSize);
													this.setContentSize(view.contents._backgroundSize);
													return view;
												});
											}
										});
									}else{
										return view;
									}
								}.bind(this));
								break;
			}
		});

		if(newViews.length){
			return Promise.all(promises)
				.then(() => {
					return this._prependSectionRollbackFinish.promise.then(()=>{
						//console.log("Clear Append Segmentation !!!!!");
						this.views.clearSegmentation();
						return this.check();
					});
				})
				.then(() => {
					// Check to see if anything new is on screen after rendering
					return this._update(delta);
				}, (err) => {
					return err;
				});
		} else {
			this.q.enqueue(function(){
				this._update();
			}.bind(this));
			checking.resolve(false);
			return checking.promise;
		}
	}

	trim(){
		//console.log("trim ------------------------------------------");
		var task = new defer();
		var displayed = this.views.displayed();
		var first = displayed[0];
		var last = displayed[displayed.length-1];
		var firstIndex = this.views.indexOf(first);
		var lastIndex = this.views.indexOf(last);
		var above = this.views.slice(0, firstIndex);
		var below = this.views.slice(lastIndex+1);

		let aboveKeepNum = 1;
		let belowKeepNum = 1;
		if (this.book.package.metadata.layout === "pre-paginated" && this.layout.props.spread) {
			if(above.length){
				let aboveLast = above[above.length-1];
				if(!aboveLast.section.properties.includes("page-spread-center") && !aboveLast.section.properties.includes("rendition:page-spread-center") && !aboveLast.section.properties.includes("page-spread-center-left") && !aboveLast.section.properties.includes("page-spread-center-right") && (aboveLast.section.properties.includes("page-spread-right") || aboveLast.section.properties.includes("rendition:page-spread-right") || aboveLast.section.properties.includes("page-spread-left") || aboveLast.section.properties.includes("rendition:page-spread-left")) ){
					aboveKeepNum = 2;
				}
			}
			if(below.length){
				let belowFirst = below[0];
				if(!belowFirst.section.properties.includes("page-spread-center") && !belowFirst.section.properties.includes("rendition:page-spread-center") && !belowFirst.section.properties.includes("page-spread-center-left") && !belowFirst.section.properties.includes("page-spread-center-right") && (belowFirst.section.properties.includes("page-spread-right") || belowFirst.section.properties.includes("rendition:page-spread-right") || belowFirst.section.properties.includes("page-spread-left") || belowFirst.section.properties.includes("rendition:page-spread-left")) ){
					belowKeepNum = 2;
				}
			}
		}

		// Erase all but last above
		let insetBeforIndex = above.length-aboveKeepNum;
		let lastAboveTarget = above[insetBeforIndex-1];
		if(insetBeforIndex > 0){
			//console.log(`above: ${insetBeforIndex} (Append Trim Segmentation !!!!!)`);
			this.views.addSegmentation("trim", insetBeforIndex+1);
		}
		for (var i = 0; i < insetBeforIndex; i++) {
			this.erase(above[i], above, lastAboveTarget);
		}

		// Erase all except first below
		for (var j = belowKeepNum; j < below.length; j++) {
			this.erase(below[j]);
		}

		task.resolve();
		return task.promise;
	}

	erase(view, above, lastAboveTarget){ //Trim

		var prevTop;
		var prevLeft;

		var nowScrollHeightRange;
		var nowScrollWidthRange;

		if(!this.settings.fullsize) {
			prevTop = this.container.scrollTop;
			prevLeft = this.container.scrollLeft;
			nowScrollHeightRange = this.container.scrollHeight - this.container.clientHeight;
			nowScrollWidthRange = this.container.scrollWidth - this.container.clientWidth;
		} else {
			prevTop = window.scrollY;
			prevLeft = window.scrollX;
			nowScrollHeightRange = window.scrollHeight - window.clientHeight;
			nowScrollWidthRange = window.scrollWidth - window.clientWidth;
		}

		var section = view.section;
		var bounds = view.bounds();

		//console.log("remove:", section);
		this.views.remove(view);
		
		if(above) {
			let rollBackPosition;
			if (this.book.package.metadata.layout === "pre-paginated") {
				rollBackPosition = prevTop - bounds.height;
				if(this.layout.props.spread){
					if(this.settings.direction === "rtl" && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center") || section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right") || section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left")) ){
						if(rollBackPosition <= nowScrollHeightRange && rollBackPosition >= bounds.height){
							//console.log("erase rollback ~~", rollBackPosition);
							this.scrollTo(0, rollBackPosition, true);
						}
					}else if(this.settings.direction === "ltr" && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center") || section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right") || section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right")) ){
						if(rollBackPosition <= nowScrollHeightRange && rollBackPosition >= bounds.height){
							//console.log("erase rollback ~~", rollBackPosition);
							this.scrollTo(0, rollBackPosition, true);
						}
					}
				}else{
					//console.log("erase rollback ~~", rollBackPosition, prevTop, bounds.height);
					this.scrollTo(0, rollBackPosition, true);
					
				}
				if(view === lastAboveTarget){
					//console.log("Clear Trim Segmentation !!!!!");
					this.views.clearSegmentation("trim");
				}
			} else if(this.settings.axis === "vertical") {
				rollBackPosition = prevTop - bounds.height;
				if(rollBackPosition <= nowScrollHeightRange){
					//console.log("erase rollback ~~", rollBackPosition);
					this.scrollTo(0, rollBackPosition, true);
				}
				//console.log("Clear Trim Segmentation !!!!!");
				this.views.clearSegmentation("trim");
			} else {
				if(this.settings.direction === 'rtl') {
					//缺可捲動範圍判斷
					if (!this.settings.fullsize) {
						this.scrollTo(prevLeft, 0, true);					
					} else {
						this.scrollTo(prevLeft + Math.floor(bounds.width), 0, true);
					}
				} else {
					if(prevLeft-Math.floor(bounds.width) <= nowScrollWidthRange){
						this.scrollTo(prevLeft - Math.floor(bounds.width), 0, true);
					}
				}
				//console.log("Clear Trim Segmentation !!!!!");
				this.views.clearSegmentation("trim");
			}
		}else{
			//console.log("Clear Trim Segmentation !!!!!");
			this.views.clearSegmentation("trim");
		}

	}

	addEventListeners(stage){

		window.addEventListener("unload", function(e){
			this.ignore = true;
			// this.scrollTo(0,0);
			this.destroy();
		}.bind(this));

		this.addScrollListeners();

		if (this.isPaginated && this.settings.snap) {
			this.snapper = new Snap(this, this.settings.snap && (typeof this.settings.snap === "object") && this.settings.snap);
		}
	}

	addScrollListeners() {
		var scroller;

		this.tick = requestAnimationFrame;

		let dir = this.settings.direction === "rtl" && this.settings.rtlScrollType === "default" ? -1 : 1;

		this.scrollDeltaVert = 0;
		this.scrollDeltaHorz = 0;

		if(!this.settings.fullsize) {
			scroller = this.container;
			this.scrollTop = this.container.scrollTop;
			this.scrollLeft = this.container.scrollLeft;
		} else {
			scroller = window;
			this.scrollTop = window.scrollY * dir;
			this.scrollLeft = window.scrollX * dir;
		}

		this._onScroll = this.onScroll.bind(this);
		this._preventScroll = this.preventScroll.bind(this);
		scroller.addEventListener("scroll", this._onScroll);
		scroller.addEventListener("keydown", this._preventScroll);
		this._scrolled = debounce(this.scrolled.bind(this), 1000);
		this._update = debounce(this.update.bind(this), 100);
		// this.tick.call(window, this.onScroll.bind(this));

		this.didScroll = false;

	}

	removeEventListeners(){
		var scroller;

		if(!this.settings.fullsize) {
			scroller = this.container;
		} else {
			scroller = window;
		}

		scroller.removeEventListener("scroll", this._onScroll);
		scroller.removeEventListener("keydown", this._preventScroll);
		this._onScroll = undefined;
		this._preventScroll = undefined;
	}

	preventScroll(event){
		var keys = [32, 33, 34, 35, 37, 38, 39, 40];
		if (keys.includes(event.keyCode)) {
			event.preventDefault();
			return false;
		}
	}

	onScroll(){

		let scrollTop;
		let scrollLeft;
		let dir = this.settings.direction === "rtl" && this.settings.rtlScrollType === "default" ? -1 : 1;

		if(!this.settings.fullsize) {
			scrollTop = this.container.scrollTop;
			scrollLeft = this.container.scrollLeft;
		} else {
			scrollTop = window.scrollY * dir;
			scrollLeft = window.scrollX * dir;
		}

		this.scrollTop = scrollTop;
		this.scrollLeft = scrollLeft;

		//觸發開始捲動事件
		if(!this._isScrolling && !this.ignore){
			this._isScrolling = true;
			this.emit(EVENTS.MANAGERS.START_SCROLL, {
				top: this.scrollTop,
				left: this.scrollLeft
			});
		}

		if(!this.ignore) {
			this._scrolled();
			//console.log("%c==Scrolling==","color: orange", this.scrollTop, this.scrollLeft);
		} else {
			this._prependSectionRollbackFinish.resolve();
			this.ignore = false;
			//console.log("%c==Ignore Scrolling==","color: orange", this.scrollTop, this.scrollLeft);
		}

		//加入預設值
		this.scrollDeltaVert = this.scrollDeltaVert || 0;
		this.scrollDeltaHorz = this.scrollDeltaHorz || 0;
		this.prevScrollTop = this.prevScrollTop || 0;
		this.prevScrollLeft = this.prevScrollLeft || 0;

		this.scrollDeltaVert += Math.abs(scrollTop-this.prevScrollTop);
		
		this.scrollDeltaHorz += Math.abs(scrollLeft-this.prevScrollLeft);

		//console.log(`%cX:${this.scrollDeltaHorz}, Y:${this.scrollDeltaVert}`,"color: orange");

		this.prevScrollTop = scrollTop;
		this.prevScrollLeft = scrollLeft;

		clearTimeout(this.scrollTimeout);
		this.scrollTimeout = setTimeout(function(){
			this.scrollDeltaVert = 0;
			this.scrollDeltaHorz = 0;
		}.bind(this), 150);

		clearTimeout(this.afterScrolled);

		this.didScroll = false;
		
	}

	scrolled() {
			//console.log("%c==SCROLLED==","font-weight: bold; color: yellow");
			this._isScrolling = false;

			this.q.enqueue(function() {
				return this.check();
			}.bind(this));

			this.emit(EVENTS.MANAGERS.SCROLL, {
				top: this.scrollTop,
				left: this.scrollLeft
			});

			clearTimeout(this.afterScrolled);
			this._finalUpdate = new defer();
			this.afterScrolled = setTimeout(function () {

				// Don't report scroll if we are about the snap
				if (this.snapper && this.snapper.supportsTouch && this.snapper.needsSnap()) {
					return;
				}

				this._finalUpdate.promise.then(() => {
					this.emit(EVENTS.MANAGERS.SCROLLED, {
						top: this.scrollTop,
						left: this.scrollLeft
					});
					this._finalUpdate = null;
				});

			}.bind(this), this.settings.afterScrolledTimeout);
	}

	next(){
		this._isWaitEmitPrependSectionRollback = false;

		let delta = this.layout.props.name === "pre-paginated" &&
								this.layout.props.spread ? this.layout.props.delta * 2 : this.layout.props.delta;

		if(!this.views.length) return;

		if(this.book.package.metadata.layout === "pre-paginated"){
			if(this.rendition.location.atEnd && (this.container.offsetHeight+this.container.scrollTop) >= this.container.scrollHeight){
				this.stage.showAlert("v-end");
				this.rendition.emit(EVENTS.CONTENTS.BOOK_FINISH, null, null);
			}
			this.scrollBy(0, this.layout.height, true);
		}else{
			if(this.isPaginated && this.settings.axis === "horizontal") {

				this.scrollBy(delta, 0, true);

			} else {

				this.scrollBy(0, this.layout.height, true);

			}
		}

		this.q.enqueue(function() {
			return this.check();
		}.bind(this));
	}

	prev(){
		this._isWaitEmitPrependSectionRollback = false;

		let delta = this.layout.props.name === "pre-paginated" &&
								this.layout.props.spread ? this.layout.props.delta * 2 : this.layout.props.delta;

		if(!this.views.length) return;

		if(this.book.package.metadata.layout === "pre-paginated"){
			if(this.rendition.location.atStart && this.container.scrollTop === 0){
				this.stage.showAlert("v-start");
			}
			this.scrollBy(0, -this.layout.height, true);
		}else{
			if(this.isPaginated && this.settings.axis === "horizontal") {

				this.scrollBy(-delta, 0, true);

			} else {

				this.scrollBy(0, -this.layout.height, true);

			}
		}

		this.q.enqueue(function() {
			return this.check();
		}.bind(this));
	}

	updateFlow(flow){
		if (this.rendered && this.snapper) {
			this.snapper.destroy();
			this.snapper = undefined;
		}

		super.updateFlow(flow, "scroll");

		if (this.rendered && this.isPaginated && this.settings.snap) {
			this.snapper = new Snap(this, this.settings.snap && (typeof this.settings.snap === "object") && this.settings.snap);
		}
	}

	currentLocation(){
		if(this.book.package.metadata.layout === "pre-paginated"){
			this.location = this.scrolledLocation();
		}else{
			if (this.isPaginated && this.settings.axis === "horizontal") {
				this.location = this.paginatedLocation();
			} else {
				this.location = this.scrolledLocation();
			}
		}
		return this.location;
	}

	destroy(){
		super.destroy();

		if (this.snapper) {
			this.snapper.destroy();
		}
	}

}

export default ExContinuousViewManager;